<template>
  <div>
    <b-row>
      <b-col lg="6" sm="6">
        <b-link
          :to="{
            name: `${
              $route.name.includes('pharmacy')
                ? 'pharmacy-category'
                : 'category'
            }`,
          }"
        >
          <statistic-card-horizontal
            icon=""
            :statistic="$t('warehouse.category')"
            class="modify"
          />
        </b-link>
      </b-col>
      <b-col lg="6" sm="6">
        <b-link
          :to="{
            name: `${
              $route.name.includes('pharmacy') ? 'pharmacy-item' : 'item'
            }`,
          }"
        >
          <statistic-card-horizontal
            icon=""
            :statistic="$t('warehouse.item')"
            class="modify"
          />
        </b-link>
      </b-col>
    </b-row>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? `${$t('common.create')} ${$t('warehouse.one-warehouse')}`
          : `${$t('common.edit')} ${$t('warehouse.one-warehouse')}`
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <b-form-group :label="$t('common.name')" label-for="name">
              <b-form-input
                v-model="EditForm.name"
                :placeholder="$t('common.name')"
              />
              <p class="text-danger mt-1">{{ errorForm.name }}</p>
            </b-form-group>
            <AutoComplete
              :label="$t('warehouse.department')"
              :placeholder="`${$t('common.select')} ${$t(
                'warehouse.department'
              )}`"
              v-model="EditForm.department_id"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="departments"
              text-title="name"
            />
            <p class="text-danger mt-1">{{ errorForm.department_id }}</p>
            <b-form-group
              :label="$t('warehouse.is-surgery-warehouse')"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-radio
                v-model="EditForm.surgery_warehouse"
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                :value="1"
                >{{ $t("common.yes") }}</b-form-radio
              >
              <b-form-radio
                v-model="EditForm.surgery_warehouse"
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                :value="0"
                >{{ $t("common.no") }}</b-form-radio
              >
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t("common.add") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-card :title="$t('warehouse.warehouse')">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("common.filter") }} {{ $t("warehouse.warehouse") }}</h2>
            <br />
          </b-col>

          <b-col md="10" cols="12">
            <b-form-group :label="$t('common.name')" label-for="Name">
              <b-form-input
                id="Name"
                v-model="warehouseName"
                :placeholder="$t('common.name')"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="d-flex align-items-center justify-content-end mt-1 mb-md-0"
          >
            <b-button variant="primary" @click="getWarehouseList()">
              {{ $t("common.search") }}
            </b-button>
          </b-col>
        </b-row>

        <!-- Search Button -->

        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("common.table") }} {{ $t("warehouse.warehouse") }}</h2>
          <b-button
            v-if="$store.state.app.permissions.includes('store-warehouse')"
            variant="primary"
            @click="show(EditForm, 'create')"
          >
            {{ $t("common.create") }} {{ $t("warehouse.one-warehouse") }}
          </b-button>
        </div>

        <b-table
          :items="data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->

              <ActionsButtons
                deletePerm="delete-warehouse"
                editPerm="update-warehouse"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
              <!-- <b-dropdown
                variant="link"
                toggle-class="p-0"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item
                  @click="show(data.item)"
                  v-if="
                    $store.state.app.permissions.includes('update-warehouse')
                  "
                >
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">Edit</span>
                </b-dropdown-item>
                <b-dropdown-item
                  @click="deleteModel(data.item)"
                  v-if="
                    $store.state.app.permissions.includes('delete-warehouse')
                  "
                >
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle ml-50">Delete</span>
                </b-dropdown-item>
              </b-dropdown> -->
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                {{ $t("warehouse.one-warehouse") }}</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="index()"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
  BFormRadio,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BLink,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    StatisticCardHorizontal,
    ActionsButtons,
    DeleteModal,
    BFormRadio,
    AutoComplete,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        name: "",
        department_id: "",
        surgery_warehouse: 0,
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        name: "",
        department_id: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        { key: "name", label: this.$t("common.name"), sortable: true },
        {
          key: "department.name",
          label: this.$t("warehouse.department"),
          sortable: true,
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      department_id: "",
      warehouseName: "",
    };
  },
  mounted() {
    if (this.$route.name.includes("pharmacy")) {
      this.tableColumns = this.tableColumns.filter(
        (item) => item.key !== "department.name"
      );
    }
    this.getWarehouseList();
  },
  methods: {
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          name: "",
          surgery_warehouse: 0,
          department_id: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.name = item.name;
        this.EditForm.surgery_warehouse = item.surgery_warehouse;
        this.EditForm.department_id = item.department_id;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },

    async getWarehouseList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/warehouse?filter[type]=${
        this.$route.name.includes("pharmacy") ? "pharmacy" : "hospital"
      }&include[]=${
        this.$route.name.includes("pharmacy") ? "" : "department"
      }&page=${this.page}&take=${this.take}&sort=-id`;

      if (this.warehouseName) {
        url += `&filter[name]=${this.warehouseName}`;
      }
      if (this.department_id) {
        url += `&filter[department_id]=${this.department_id}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/warehouse/${this.deleteForm.id}`)
        .then((response) => {
          this.getWarehouseList();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      this.loading = true;
      let count = 0;
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }
      this.EditForm.type = this.$route.name.includes("pharmacy")
        ? "pharmacy"
        : "hospital";

      if (!this.EditForm.name) {
        this.errorForm.name = "The name field is required.";
        this.loading = false;
        count++;
      }
      if (!this.EditForm.department_id) {
        this.errorForm.department_id = "The department field is required.";
        this.loading = false;
        count++;
      }
      if (count > 0) return false;

      const dataForm = {
        ...this.EditForm,
        department_id: this.EditForm.department_id?.id || this.EditForm.department_id
      }

      if (this.createMode) {
        (this.params.form = dataForm),
          (this.params.path = `/warehouse`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getWarehouseList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = dataForm),
          (this.params.path = `/warehouse/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getWarehouseList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
